<template>
    <div class="area-container" v-loading="syncing" element-loading-text="同步中，请稍候...">
        <div class="header-actions">
            <el-button type="primary" @click="handleSync">
                <el-icon><Refresh /></el-icon>
                同步数据
            </el-button>
            <el-button :loading="refreshLoading" @click="loadRoot">
                <el-icon><Refresh /></el-icon>
                刷新
            </el-button>
        </div>

        <div class="tree-container">
            <el-tree
                :data="areaTree"
                :props="treeProps"
                node-key="value"
                highlight-current
                :lazy="true"
                :load="loadNode"
            >
                <template #default="{ node, data }">
                    <div class="tree-node-wrapper">
                        <div class="node-content" :class="{ 'node-disabled': data.isDeleted === '1' }">
                            <span class="node-label">{{ node.label }}</span>
                            <span class="node-code">({{ data.value }})</span>
                        </div>

                        <div class="node-actions">
                            <el-button
                                v-if="data.isDeleted === '1'"
                                link
                                type="primary"
                                size="small"
                                @click.stop="handleToggleStatus(data)"
                            >
                                启用
                            </el-button>
                            <el-button
                                v-else
                                link
                                type="danger"
                                size="small"
                                @click.stop="handleToggleStatus(data)"
                            >
                                禁用
                            </el-button>
                            <el-button
                                link
                                type="primary"
                                size="small"
                                @click.stop="handleAddChild(data)"
                            >
                                添加子级
                            </el-button>
                            <el-button
                                link
                                type="danger"
                                size="small"
                                @click.stop="handleDelete(data)"
                            >
                                删除
                            </el-button>
                        </div>
                    </div>
                </template>
            </el-tree>
        </div>

        <!-- 新增地址弹窗 -->
        <el-dialog
            v-model="dialogVisible"
            title="新增地址"
            width="500px"
            destroy-on-close
        >
            <el-form
                ref="formRef"
                :model="formData"
                :rules="formRules"
                label-width="100px"
                class="list-modal-form"
            >
                <el-form-item label="地址编码" prop="code">
                    <el-input
                        v-model="formData.code"
                        placeholder="请输入地址编码"
                        maxlength="50"
                        show-word-limit
                    ></el-input>
                </el-form-item>
                <el-form-item label="地址名称" prop="name">
                    <el-input
                        v-model="formData.name"
                        placeholder="请输入地址名称"
                        maxlength="100"
                        show-word-limit
                    ></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="sortOrder">
                    <el-input-number
                        v-model="formData.sortOrder"
                        :min="0"
                        placeholder="排序"
                        style="width: 100%"
                    ></el-input-number>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleSubmit">确定</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
    import { watch } from 'vue'
    import useAreaList from './areaList.js'

    const {
        areaTree,
        treeProps,
        dialogVisible,
        formRef,
        formData,
        formRules,
        Refresh,
        syncing,
        refreshLoading,
        loadRoot,
        loadNode,
        handleSync,
        handleAddChild,
        handleToggleStatus,
        handleDelete,
        handleSubmit
    } = useAreaList()

    // 监听同步状态变化
    let prevSyncing = false
    watch(syncing, (newVal) => {
        if (!newVal && prevSyncing) {
            // 同步完成，刷新数据
            loadRoot()
        }
        prevSyncing = newVal
    })
</script>

<style scoped>
.area-container {
    padding: 20px;
}

.header-actions {
    margin-bottom: 20px;
}

.tree-container {
    background: white;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    padding: 20px;
    min-height: 400px;
}

.tree-node-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 4px 0;
}

.node-content {
    flex: 1;
    display: flex;
    align-items: center;
}

.node-label {
    font-size: 14px;
}

.node-code {
    color: #909399;
    margin-left: 8px;
    font-size: 12px;
}

.node-disabled {
    opacity: 0.5;
}

.node-actions {
    display: flex;
    gap: 8px;
    opacity: 0;
    transition: opacity 0.2s;
}

.tree-node-wrapper:hover .node-actions {
    opacity: 1;
}
</style>
